var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-draggable-resizable",
    {
      staticClass: "home-form-container",
      attrs: {
        active: true,
        w: _vm.width,
        h: _vm.height,
        x: _vm.posX,
        y: _vm.posY,
        parent: true,
        resizable: true,
        "class-name-handle": "object-form-resizable-handle",
        "drag-handle": ".drag"
      },
      on: { dragstop: _vm.onDragStop, resizing: _vm.onResizing }
    },
    [
      _c(
        "div",
        { ref: "detailForm", staticClass: "form" },
        [
          _c("form-header", {
            attrs: { title: _vm.pageTitle },
            on: { close: _vm.close }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-nav" },
            _vm._l(_vm.tabs, function(tab, index) {
              return tab.show
                ? _c(
                    "div",
                    {
                      key: tab.label,
                      staticClass: "form-nav-tab",
                      class: { active: _vm.activeTab === index },
                      on: {
                        click: function($event) {
                          _vm.activeTab = index
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$tc(tab.label, 1)) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e()
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tableContainer" },
            [
              _c("detail-data-table", {
                attrs: {
                  "original-data": _vm.tabs[_vm.activeTab].data,
                  "max-height": _vm.height
                },
                on: { "resize-tab": _vm.resizeTab }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "saveDiv" })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-514d8f64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-514d8f64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/ObjectForms/DetailForm.vue
// module id = null
// module chunks = 